import http from "../redux/http";

export const getTagsAPI = async (size, page, type, category, search) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (type) params.type = type;
  if (category) params.category = category;
  if (search) params.search = search;

  try {
    const { data } = await http.get("/tags", {
      params,
    });

    return data.data;
  } catch (error) {
    return error;
  }
};

export const getBlogTagsAPI = async ({
  size,
  page,
  type,
  category,
  search,
}) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (type) params.type = type;
  if (category) params.category = category;
  if (search) params.search = search;

  return await http.get("/tags", {
    params,
  });
};

export const getKeywordsAPI = async () =>
  await http.get("/tags/used-post-count?type=keyword");

export const followTagAPI = async (tagId) => http.put(`/tags/${tagId}/follows`);

export const unfollowTagAPI = async (tagId) =>
  http.delete(`/tags/${tagId}/follows`);
